import React from 'react';

import H2 from 'apps/Pdf/components/common/H2';

import { isoDateTimeToLabelZoned, formatAmount } from 'helpers/helpers';
import useTableStyles from 'apps/Pdf/styles/tables';
import useGeneralStyles from 'apps/Pdf/styles/general';
import { InterestsData } from '../StatementInterface';
import { AmountValue } from 'common/interfaces';
import { Currency } from 'enums';

interface Props {
  data: InterestsData[];
  currency: Currency;
  total: AmountValue;
}

const InterestsTable = (props: Props) => {
  const styles = useGeneralStyles();
  const tables = useTableStyles();
  const { data } = props;

  return (
    <>
      {data.length ? (
        <>
          <H2>Připsané úroky z úročené hotovosti a dividendy</H2>
          <table className={`${tables.root} ${tables.overview} ${tables.transactions}`}>
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th>Datum připsání</th>
                <th>Typ</th>
                <th>Částka</th>
                <th>Srážková daň</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={`item_${item.date}`} className={styles.value}>
                  <td className="T1">&nbsp;</td>
                  <td>{isoDateTimeToLabelZoned(item.date, 'd. M. yyyy')}</td>
                  <td>{item.type === 'INTEREST' ? 'Připsaný úrok' : 'Dividenda'}</td>
                  <td className={styles.value}>{formatAmount(item.value, props.currency)}</td>
                  <td className={styles.value}>
                    {item.deductionTax !== undefined && formatAmount(item.deductionTax, props.currency)}
                  </td>
                </tr>
              ))}
              {props.total && (
                <tr className="sum">
                  <td>&nbsp;</td>
                  <td colSpan={2}>Celkem (čisté úroky)</td>
                  <td />
                  <td className={styles.left}>{formatAmount(props.total, props.currency)}</td>
                </tr>
              )}
            </tbody>
          </table>
        </>
      ) : null}
    </>
  );
};

export default InterestsTable;
